import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { resolveAppEndpoints } from '../core/app-endpoints';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private baseUrl: string;
    private baseUrlFrontend: string;
    private appId: string;

    constructor(private http: HttpClient) {
        const endpoints = resolveAppEndpoints();
        this.baseUrl = endpoints.authApiBaseUrl;
        this.baseUrlFrontend = endpoints.authAppBaseUrl;
        this.appId = 'acl';
    }

    loginUrl(): string {
        return `${this.baseUrlFrontend}/login?appId=${this.appId}&redirectUrl=${window.location.origin}`;
    }

    registerUrl(): string {
        return `${this.baseUrlFrontend}/register?appId=${this.appId}&redirectUrl=${window.location.origin}`;
    }

    async isLoggedIn(): Promise<boolean> {
        return await this.verify();
    }

    async verify(): Promise<boolean> {
        try {
            const response = await firstValueFrom(this.http.get<any>(`${this.baseUrl}/auth/verify/${this.appId}`, { withCredentials: true }));
            if (response.valid) {
                this.setUserId(response.userId);
                this.setUserEmail(response.email);
                this.setUserFirstName(response.firstName);
                this.setUserLastName(response.lastName);
                this.setOrganizationId(response.organizationId);
                this.setOrganizationName(response.organizationName);
                return true;
            }
            return false
        } catch (error) {
            return false;
        }
    }

    async logout(): Promise<void> {
        localStorage.removeItem('userId');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userFirstName');
        localStorage.removeItem('userLastName');
        localStorage.removeItem('activeBrandId');
        await firstValueFrom(this.http.post(`${this.baseUrl}/auth/logout`, {}, { withCredentials: true }));
    }

    setUserId(userId: string): void {
        localStorage.setItem('userId', userId);
    }

    getUserId(): string | null {
        return localStorage.getItem('userId');
    }

    setUserEmail(email: string): void {
        localStorage.setItem('userEmail', email);
    }

    setOrganizationId(organizationId: string): void {
        localStorage.setItem('organizationId', organizationId);
    }

    setOrganizationName(organizationName: string): void {
        localStorage.setItem('organizationName', organizationName);
    }

    getUserEmail(): string | null {
        return localStorage.getItem('userEmail');
    }

    setUserFirstName(firstName: string): void {
        localStorage.setItem('userFirstName', firstName);
    }

    getUserFirstName(): string | null {
        return localStorage.getItem('userFirstName');
    }

    setUserLastName(lastName: string): void {
        localStorage.setItem('userLastName', lastName);
    }

    getUserLastName(): string | null {
        return localStorage.getItem('userLastName');
    }

    getOrganizationId(): string | null {
        return localStorage.getItem('organizationId');
    }

    getOrganizationName(): string | null {
        return localStorage.getItem('organizationName');
    }
} 